import { createContext, useReducer, useEffect } from 'react'

export const CountryContext = createContext()

const initialState = []

export const countryReducer = (state, action) => {
	switch (action.type) {
		case 'ADD_COUNTRY':
			return { countries: action.payload }
		case 'REMOVE_COUNTRY':
			return { countries: action.payload }
		default:
			return state
	}
}

export const CountryContextProvider = ({ children }) => {
	const [state, dispatch] = useReducer(countryReducer, initialState, () => {
		try {
			const localCountries = localStorage.getItem('countries')
			return localCountries ? JSON.parse(localCountries) : initialState
		} catch (error) {
			//Ideally this is where I would dispatch an 'ERROR' to the Reducer
			console.log(error)
		}
	})

	useEffect(() => {
		localStorage.setItem('countries', JSON.stringify(state))
	}, [dispatch, state])

	return (
		<CountryContext.Provider value={{ ...state, dispatch }}>
			{children}
		</CountryContext.Provider>
	)
}
